import React, { useState, useEffect, useContext, createContext } from "react";

import { getPublicData } from "API/calls";

export type IPublicDataContext = {
  refreshPublicData?: () => void;
  vapidPublicKey: string | null;
  loading: boolean;
};

const defaultState: IPublicDataContext = {
  vapidPublicKey: null,
  loading: true,
};

const PublicDataContext = createContext<IPublicDataContext>(defaultState);

export const PublicDataProvider: React.FC<{}> = ({ children }) => {
  const [vapidPublicKey, setVapidPublicKey] = useState<string | null>(defaultState.vapidPublicKey);
  const [loading, setLoading] = useState<boolean>(defaultState.loading);

  useEffect(() => {
    loadPublicData();
  }, []);

  async function loadPublicData() {
    try {
      const response = (await getPublicData()).data;
      if (response) {
        setVapidPublicKey(response.vapidPublicKey);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <PublicDataContext.Provider
      value={{
        vapidPublicKey,
        loading,
        refreshPublicData: () => loadPublicData(),
      }}>
      {children}
    </PublicDataContext.Provider>
  );
};

export const usePublicDataContext = () => useContext(PublicDataContext);
